export default "__VITE_ASSET__BwC4TSOj__"